<template>
    <div class="payout-detail">
       <TableResults v-if="step === 0" />
        <template v-else>
            <div v-if="name !== ''" class="payout-detail__header">{{ getTranslatedText(`Loto ${name} Winnings`) }}</div>
            <Payout645 v-if="propsDataGames.name === 'lotto-6-45'" />
            <Payout459 v-else-if="CT_GAME_SLUG.LOTTO_459.includes(propsDataGames.name)" />
            <Payout545 v-else-if="propsDataGames.name === 'lotto-5-45'" />
            <PayoutDoubleChance v-else-if="step === CTPayout.LOTTO_DOUBLE_CHANGE.slug" />
            <Payout590 
                v-else-if="
                    step === CTPayout.LOTTO_TURBO.slug || 
                    step === CTPayout.LOTTO_CHANCE.slug ||
                    step === CTPayout.LOTTO_CHANCE_PLUS.slug "
                :data-source="listLoto"/>
            <PayoutExtra v-else-if="step === 4" />
            <template v-else>
                <div v-if="!isPariMutuelLotto" class="payout-detail__content" v-for="(item, key) in listLoto" :key="key">
                    <template>
                        <b>{{ getTranslatedText(item.name + ': ' + item.countWin) }}</b>
                        <table>
                            <tr>
                                <th class="number">{{ getTranslatedText('Number Of Winning Numbers') }}</th>
                                <th class="bet">{{ getTranslatedText('Bet') }}</th>
                                <th class="earnings">{{ getTranslatedText('Earnings') }}</th>
                            </tr>
                            <tr>
                                <td class="cell">
                                    <span v-for="(data, index) in item.winningNumbers" :key="index">{{ getTranslatedText(data.value) }}</span>
                                </td>
                                <td>{{ renderPrice(item.bet) + ' ' + item.currency }}</td>
                                <td class="cell">
                                    <span v-for="(value, i) in item.earnings" :key="i">{{ renderPrice(value) }}</span>
                                </td>
                            </tr>
                        </table>
                    </template>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import listLotoPayouts from '@/resources/data/payouts.json'
import EventBus from '@/utils/EventBus'
import TableResults from '@/components/results/table-results/index.vue'

import Payout590 from '@/components/payouts/payout-detail/payout590/index.vue'
import Payout645 from '@/components/payouts/payout-detail/payout645/index.vue'
import Payout545 from '@/components/payouts/payout-detail/payout545/index.vue'
import Payout459 from '@/components/payouts/payout-detail/payout459/index.vue'
import PayoutExtra from '@/components/payouts/payout-detail/payoutExtra/index.vue'
import PayoutDoubleChance from '@/components/payouts/payout-detail/payoutDoubleChance/index.vue'
import { formatPrice } from '@/utils/utils'
import { CTPayout } from '@/constants/payout'
import { RS_DATA_CHANCE, RS_DATA_CHANCE_PLUS, RS_DATA_TURBO } from '@/resources/data/payouts'
import { CT_GAME_SLUG } from '@/constants/game'
export default {
    mixins: [languageMixins],
    components: { TableResults, Payout590, Payout645, Payout545, Payout459, PayoutExtra, PayoutDoubleChance },
    props: {
        step: {
            type: Number | String,
            default: 1,
        },
        isPariMutuelLotto: {
            type: Boolean,
            default: false,
        },
        propsDataGames: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            listLoto: [],
            name: 'Turbo',
            listLotoPayouts,
            CTPayout,
            CT_GAME_SLUG
        }
    },
    watch: {
        step() {
            this.fetchDataLoto(this.step)
        },
    },
    created() {
        this.fetchDataLoto(this.step)
    },
    destroyed() {
        EventBus.$off('on-change-step-screen-results')
    },

    methods: {
        fetchDataLoto(step) {
            if (step === CTPayout.LOTTO_TURBO.slug) {
                this.listLoto = RS_DATA_TURBO
                this.name = CTPayout.LOTTO_TURBO.title
            } else if (step === 2) {
                this.listLoto = listLotoPayouts.nap
                this.name = 'nap'
            } else if (step === CTPayout.LOTTO_CHANCE.slug) {
                this.listLoto = RS_DATA_CHANCE
                this.name = CTPayout.LOTTO_CHANCE.title
            } else if(step === 4) {
                this.name = 'Extra'
            } else if(step === CTPayout.LOTTO_DOUBLE_CHANGE.slug) {
                this.name = ''
            } else if(step === CTPayout.LOTTO_CHANCE_PLUS.slug) {
                this.listLoto = RS_DATA_CHANCE_PLUS
                this.name = CTPayout.LOTTO_CHANCE_PLUS.title
            } else {
                if (this.propsDataGames.name === 'lotto-5-45') {
                    this.name = '5/45'
                } else if (CT_GAME_SLUG.LOTTO_459.includes(this.propsDataGames.name?.toLowerCase())) {
                    this.name = '4/59'
                } else {
                    this.name = '6/45'
                }
            }
            this.step = step
        },

        renderPrice(price) {
            let decimal = this.isPariMutuelLotto ? 2 : 0
            return formatPrice(price, decimal)
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/payouts/_payout-detail.scss';
</style>
